import { cn } from '@repo/zolintra-utils';
// Components
import { PageLayout, Dialog } from '@repo/zolintra-ui';
// Hooks
import { useTranslation } from 'react-i18next';
import { useDialog } from '../../hooks/useDialog';
import { useAppContext } from '../../store/AppContext';
import useResources from '../../hooks/domain/useResources';
import useAuth from '../../hooks/useAuth';
// Styles
import styles from './RemoteWorkingAndLeave.module.css';
// SubViews
import PlanningSubView from './subViews/PlanningSubView';

function PlanningRemoteWorkingAndLeave() {
  // Hooks
  const [{ user }] = useAppContext();
  const { t } = useTranslation();
  const { isOpen, dialog } = useDialog();
  const { getResourceDisplayName } = useResources();
  const { handleLogout } = useAuth();

  return (
    <PageLayout
      title={t('remoteWorkingAndLeave.planningBtnLabel')}
      user={{
        name: getResourceDisplayName(user, true),
        photo: user.photo,
      }}
      logout={{ label: t('common.logout'), handleLogout }}
      className={styles['view-layout-planning']}
    >
      <div className={styles.layout}>
        <div className={cn([styles['view-content'], styles['view-content-planning']])}>
          <PlanningSubView />
        </div>
      </div>

      <Dialog
        title={dialog.title}
        onClose={() => dialog.onClose()}
        isOpen={isOpen}
        topRightContent={dialog.topRightContent}
        footer={dialog.footer}
      >
        {dialog.children}
      </Dialog>
    </PageLayout>
  );
}

PlanningRemoteWorkingAndLeave.propTypes = {};

export default PlanningRemoteWorkingAndLeave;
